// Export factory functions and methods

export { equals } from "./equals.js";
export { from } from "./from.js";
// Export type definitions
export type { ProofLike, ProofType } from "./ProofType.js";
export { verify } from "./verify.js";
